module.exports = __webpack_public_path__ + "54cf98f5/img/grid-web-icon.d0395d64.svg";